(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
      this.scrollTolerance = 11;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(min-width: 990px)');
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const height = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      document.documentElement.style.setProperty('--dd-header-height', `${height}px`);
      if (!this.header.classList.contains('shopify-section-header-hidden')) {
        document.documentElement.style.setProperty('--dd-header-visible-height', `${height}px`);
      }
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.cancelAnimationFrame(this.scrollFrame);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    queueScrollUpdate(update) {
      window.cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = undefined;
        if (!this.anchorNavigation) update.call(this);
      });
    }

    beginAnchorNavigation(destination) {
      if (!this.header || [...this.predictiveSearches].some((search) => search.isOpen)) return false;
      window.cancelAnimationFrame(this.scrollFrame);
      this.anchorNavigation = true;
      // Settle header and hotlink-bar geometry in the same task as native navigation.
      this.header.classList.remove('animate');
      if (destination <= (this.headerBounds.top || 0)) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      } else {
        this.header.classList.add('scrolled-past-header');
        this.hide();
      }
      return true;
    }

    endAnchorNavigation() {
      this.anchorNavigation = false;
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.anchorNavigation) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop <= this.headerBounds.top) {
        this.currentScrollTop = scrollTop;
        this.header.classList.remove('scrolled-past-header');
        this.queueScrollUpdate(this.reset);
        return;
      }

      const scrollDelta = scrollTop - this.currentScrollTop;
      if (Math.abs(scrollDelta) < this.scrollTolerance) return;

      if (scrollDelta > 0 && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        this.queueScrollUpdate(this.hide);
      } else if (scrollDelta < 0 && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          this.queueScrollUpdate(this.reveal);
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.queueScrollUpdate(this.hide);
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.documentElement.style.setProperty('--dd-header-visible-height', '0px');
      document.dispatchEvent(new CustomEvent('dd:header-visibility', { detail: { visible: false, height: 0 } }));
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.documentElement.style.setProperty('--dd-header-visible-height', `${this.header.offsetHeight}px`);
      document.dispatchEvent(
        new CustomEvent('dd:header-visibility', { detail: { visible: true, height: this.header.offsetHeight } })
      );
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.documentElement.style.setProperty('--dd-header-visible-height', `${this.header.offsetHeight}px`);
      document.dispatchEvent(
        new CustomEvent('dd:header-visibility', { detail: { visible: true, height: this.header.offsetHeight } })
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
